import React, { Component } from 'react';
import StatCard from './StatCard';

class GridStats extends Component {
    state = {};

    renderStatCards = () => {
        const { syncroStats, literals } = this.props;
        let gridStats = syncroStats.data.entities.map((item) => {
            return (
                <StatCard
                    data={item}
                    key={item.entity}
                    literals={{
                        ...literals,
                        integration_entity_text: syncroStats.metaData[item.entity],
                    }}
                    entity={item.entity}
                />
            );
        });
        return gridStats;
    };

    render() {
        return <div className="integration-grid">{this.renderStatCards()}</div>;
    }
}

export default GridStats;
